import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { HTTPService, HelperService, DateService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import { sortBy } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ngx-bulk-payment-pdf',
  templateUrl: './bulk-payment-pdf.component.html',
  styleUrls: ['./bulk-payment-pdf.component.scss'],
})
export class BulkPaymentPdfComponent implements OnInit {
  company: any = { address: {} };
  customer: any = {};
  usd: string = currency.USD;
  pdfLogoType: string = '';
  pdfImage: any = {};
  statement: any = {
    invoices: [],
  };
  totalVehicle: number = 0;
  statementTotal = {
    total: 0,
    due: 0,
    paid: 0,
    balanceDue: 0,
    oldPayments: 0,
    currentPayment: 0,
  };
  statementRange = {
    start: '',
    end: '',
  };
  token: string = '';
  invoiceLinks: any = {};
  paymentLinks: any = {};
  payment: any = {};
  invoicesList: any[] = [];
  isPreview: boolean = false;
  companyLocalization: boolean = false;
  currentLang: string = 'en';

  constructor(private activatedRoute: ActivatedRoute, private httpService: HTTPService, public helperService: HelperService, private dateService: DateService,private translate:TranslateService) {}

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get('reciept_token');
    const type = this.activatedRoute.snapshot.paramMap.get('type');
    this.companyLocalization = this.activatedRoute.snapshot.queryParamMap.get('localization') === 'true';
    if (this.companyLocalization) {
      this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang');
      this.currentLang = this.helperService.validatePreferredLang(this.currentLang);
    }

    this.translate.use(this.currentLang);

    if (type !== 'download') {
      this.isPreview = true;
      this.getBulkPayment();
    } else {
      this.httpService.downloadBulkPaymentPdfDocument(this.token).then(
        (url: string) => {
          window.open(url);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  getBulkPayment() {
    if (!this.token) return;

    this.httpService.getBulkPaymentByToken(this.token).then(
      ({ statement, payment, company, shop, customer, invoiceLinks, paymentLinks }) => {
        const vehicle = [];

        if (payment && payment.invoices && payment.invoices.length) {
          const paymentMap = {};

          payment.paymentIds.forEach((payment: any) => {
            if (payment.estimate && payment.estimate.estimateId) {
              paymentMap[payment.estimate.estimateId] = payment;
            }
          });

          payment.invoices.forEach((invoice: any) => {
            if (invoice.vehicle && invoice.vehicle.vehicleId && !vehicle.includes(invoice.vehicle.vehicleId)) {
              vehicle.push(invoice.vehicle.vehicleId);
            }

            const payment = paymentMap[invoice._id];
            const paid = invoice.cheque + invoice.cash + invoice.card + invoice.creditPayment + invoice.thirdParty;

            this.statementTotal.paid += paid;
            this.statementTotal.due += invoice.total.grand - paid;

            const invoiceItem = {
              _id: invoice._id,
              paymentCode: '',
              invoiceLink: invoiceLinks[invoice._id],
              paymentLink: '',
              invCode: invoice.invCode,
              title: invoice.title,
              invoiceDate: this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(invoice.invoiceDate).getTime(), company.timezone), datetimeFormat.mmmdyyyy),
              totalValue: invoice.total.grand,
              oldPayments: paid,
              currentPayment: 0,
              due: invoice.total.grand - paid,
            };

            if (payment) {
              invoiceItem.paymentCode = payment.code;
              invoiceItem.currentPayment = payment.amount;
              invoiceItem.oldPayments = paid - payment.amount;
              invoiceItem.paymentLink = paymentLinks[invoice._id];

              this.statementTotal.currentPayment += invoiceItem.currentPayment;
              this.statementTotal.oldPayments += invoiceItem.oldPayments;
            }

            this.statementTotal.total += invoiceItem.totalValue;

            this.statementTotal.balanceDue += invoiceItem.due;

            this.invoicesList.push(invoiceItem);
          });
        }

        this.totalVehicle = vehicle.length;
        this.statement = statement;
        this.company = company;
        this.customer = customer;
        this.invoiceLinks = invoiceLinks;
        this.paymentLinks = paymentLinks;

        payment.paymentDate = this.dateService.getCurrentDateTimeTz(new Date(payment.paymentDate).getTime(), company.timezone);
        this.payment = payment;

        const sortedOrder: any = sortBy(Object.values(this.statement.invoices), 'invoiceDate');

        if (sortedOrder[0]) {
          this.statementRange.start = sortedOrder[0].invoiceDate;
          this.statementRange.end = sortedOrder[sortedOrder.length - 1].invoiceDate;
        }

        if (this.customer && this.customer.address) {
          const { addLine1, city, stateCode, zip } = this.customer.address;
          const addressArr = [addLine1 || '', city || '', stateCode || ''];

          if (addLine1 || city || stateCode || zip) {
            addressArr.push(this.customer.address.country || '');
          }
          addressArr.push(this.customer.address.zip || '');
          this.customer.address = addressArr.filter((str) => !!str).join(', ');
        }

        if (this.company && this.company.address) {
          const { zip, city, country, addLine1, stateCode } = this.company.address;

          const addressArr = [addLine1 || '', city || '', stateCode || '', country || '', zip || ''];
          this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
        }

        if (this.company.appsettings?.isMultiLocationEnabled && shop) {
          const shopDetailsKey = ['name', 'logo', 'email', 'phone'];

          shopDetailsKey.forEach((key: string) => {
            if (shop[key]) {
              this.company[key] = shop[key];
            }
          });

          if (shop.pdfLogo) {
            this.company.logo = shop.pdfLogo;
            this.company.pdfLogo = shop.pdfLogo;
            this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
          }

          if (shop.address?.addLine1) {
            const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = shop.address;
            const addressArr = [addLine1, city, stateCode, country, zip];

            this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
          }
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }
}
